import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Popconfirm,
  Popover,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import React, {useState, useEffect, useRef} from "react";
import "./OfferList.scss";
import {data} from "./config";
import {ColumnProps} from "types/models";
import Icons from "assets/icons";
import {ExcelSVG, ListIconSVG} from "assets";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ColumnPopoverDisplay from "./components/ColumnPopoverDisplay/ColumnPopoverDisplay";
import DetailInfo from "./components/DetailInfo/DetailInfo";
import {EyeOutlined} from "@ant-design/icons";
import OfferContent from "./components/OfferContent/OfferContent";

const OfferList = () => {
  const [form] = Form.useForm();
  const modalRef = useRef<any>();
  const detailModalRef = useRef<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [expand, setExpand] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>(data);
  const [previewData, setPreviewData] = useState<any>(null);

  const allColumns: ColumnProps[] = [
    {
      title: "STT",
      key: "stt",
      dataIndex: "stt",
      show: true,
      align: "center",
      render: (_v, _r, idx) => idx + 1,
    },
    {title: "Mã CT", dataIndex: "maChuonTrinh", show: true, align: "left"},
    {title: "Tên CT", dataIndex: "tenChuongTrinh", show: true, align: "left"},
    {title: "Ngày tạo", dataIndex: "ngayTao", show: true, align: "left"},
    {title: "Người tạo", dataIndex: "nguoiTao", show: true, align: "left"},
    {title: "Người duyệt", dataIndex: "nguoiDuyet", show: true},
    {title: "Áp dụng từ", dataIndex: "apDungTu", show: true},
    {title: "Áp dụng đến", dataIndex: "apDungDen", show: true},
    {title: "Mô tả", dataIndex: "moTa", show: true},
    {title: "Trạng thái", dataIndex: "trangThai", show: true},
    {
      title: "Thao tác",
      key: "action",
      dataIndex: "action",
      align: "center",
      show: true,
      render: (value, record, idx) => {
        const showDetail = () => {
          setPreviewData(record);
          detailModalRef.current.openModal();
        };
        return (
          <Row justify={"center"}>
            <Popconfirm className="danger-confirm" title="Bạn muốn xóa?">
              <Button
                type="ghost"
                icon={<Icons.remove rev={0} style={{color: "#ff3300"}} />}
                danger
              />
            </Popconfirm>
            <Popconfirm className="danger-confirm" title="Bạn muốn chỉnh sửa?">
              <Button type="ghost" icon={<Icons.edit rev={0} />} />
            </Popconfirm>
            <Button
              type="ghost"
              icon={<EyeOutlined rev={0} />}
              onClick={e => showDetail()}
            />
          </Row>
        );
      },
    },
  ];
  const [columns, setColumns] = useState<ColumnProps[]>(
    allColumns.filter(e => e.show == true)
  );
  const setShowColumns = showColumns => {
    setColumns(showColumns);
  };
  const toggleExpand = e => {
    setExpand(!expand);
  };

  const onNew = e => {
    modalRef.current?.openModal();
  };
  const onFinishModal = values => {
    //validate values
    setLoading(true);
    setTableData([...tableData, values]);
    setLoading(false);
  };

  const onFinish = values => {};
  useEffect(() => {}, []);

  return (
    <Spin spinning={loading}>
      <div className="customer-list">
        <div className="container">
          <Row gutter={[0, 8]}>
            <Form
              form={form}
              size="large"
              labelAlign="left"
              onFinish={onFinish}
            >
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>
                        Mã chương trình
                      </Typography.Text>
                    }
                    labelAlign="left"
                    labelCol={{span: 8}}
                    wrapperCol={{
                      span: 16,
                    }}
                    name="maChuongTrinh"
                  >
                    <Input className="data-input-field" placeholder="Nhập" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>
                        Tên chương trình
                      </Typography.Text>
                    }
                    labelAlign="left"
                    labelCol={{span: 8}}
                    wrapperCol={{
                      span: 16,
                    }}
                    name="tenChuongTrinh"
                  >
                    <Input className="data-input-field" placeholder="Nhập" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Ngày tạo</Typography.Text>}
                    labelAlign="left"
                    labelCol={{span: 8}}
                    wrapperCol={{
                      span: 16,
                    }}
                    name="ngayTao"
                  >
                    <DatePicker
                      className="data-picker-field"
                      placeholder="DD/MM/YYYY"
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Người tạo</Typography.Text>
                    }
                    labelAlign="left"
                    labelCol={{span: 8}}
                    wrapperCol={{
                      span: 16,
                    }}
                    name="nguoiTao"
                  >
                    <Input className="data-input-field" placeholder="Nhập" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Áp dụng từ</Typography.Text>
                    }
                    labelAlign="left"
                    labelCol={{span: 8}}
                    wrapperCol={{
                      span: 16,
                    }}
                    name="apDungTu"
                  >
                    <DatePicker
                      className="data-picker-field"
                      placeholder="DD/MM/YYYY"
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Áp dụng đến</Typography.Text>
                    }
                    labelAlign="left"
                    labelCol={{span: 8}}
                    wrapperCol={{
                      span: 16,
                    }}
                    name="apDungDen"
                  >
                    <DatePicker
                      className="data-picker-field"
                      placeholder="DD/MM/YYYY"
                      format={"DD/MM/YYYY"}
                    />
                  </Form.Item>
                </Col>

                {expand && (
                  <>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <Form.Item
                        label={
                          <Typography.Text ellipsis>Nhóm BN</Typography.Text>
                        }
                        labelAlign="left"
                        labelCol={{span: 8}}
                        wrapperCol={{
                          span: 16,
                        }}
                        name="nguonBn"
                      >
                        <Select
                          className="data-select-field"
                          placeholder="Chọn"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <Form.Item
                        label={
                          <Typography.Text ellipsis>Nhóm BN</Typography.Text>
                        }
                        labelAlign="left"
                        labelCol={{span: 8}}
                        wrapperCol={{
                          span: 16,
                        }}
                        name="nguonBn"
                      >
                        <Select
                          className="data-select-field"
                          placeholder="Chọn"
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>
            </Form>
            <Row justify={"end"}>
              <Space size={"middle"}>
                <Button
                  type="default"
                  icon={
                    !expand ? (
                      <Icons.down rev={0}></Icons.down>
                    ) : (
                      <Icons.up rev={0}></Icons.up>
                    )
                  }
                  onClick={toggleExpand}
                >
                  Tìm nâng cao
                </Button>
                <Button
                  icon={<Icons.search rev={0}></Icons.search>}
                  type="primary"
                  htmlType="submit"
                >
                  Tìm kiếm
                </Button>
              </Space>
            </Row>
          </Row>
        </div>

        <Row className="container table-box">
          <Space direction="vertical">
            <Row justify={"space-between"} gutter={[16, 16]}>
              <Col span={12}>
                <Button icon={<ExcelSVG />} className="btn-svg">
                  Xuất báo cáo
                </Button>
              </Col>
              <Col span={12}>
                <Row justify={"end"}>
                  <Popover
                    trigger="click"
                    placement="topLeft"
                    content={
                      <ColumnPopoverDisplay
                        setShowColumns={setShowColumns}
                        columns={allColumns}
                      ></ColumnPopoverDisplay>
                    }
                  >
                    <Button
                      style={{
                        color: "white",
                        background: "#003828",
                        height: "40px",
                      }}
                      className="icon-button"
                      icon={<ListIconSVG />}
                    >
                      Cột hiển thị
                    </Button>
                  </Popover>
                  <Button
                    icon={<Icons.add rev={0} />}
                    type="primary"
                    onClick={onNew}
                  >
                    Thêm mới
                  </Button>
                  <ModalCustom
                    ref={modalRef}
                    width={800}
                    title="Thêm trạng thái"
                  >
                    <OfferContent {...{form: form, onFinish: onFinishModal}} />
                  </ModalCustom>
                  <ModalCustom
                    ref={detailModalRef}
                    width={800}
                    title="Chi tiết chương trình ưu đãi"
                  >
                    <DetailInfo previewData={previewData} />
                  </ModalCustom>
                </Row>
              </Col>
            </Row>
            <Table
              rowKey={record => record.id}
              columns={columns}
              dataSource={tableData}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                showSizeChanger: true,
                // onShowSizeChange: onShowSizeChange,
                // total: data.total,
                // current: page,
              }}
            />
          </Space>
        </Row>
      </div>
    </Spin>
  );
};

export default OfferList;
